import Model from './Model'

export default class TenantUserModel extends Model {
  public id: number|undefined

  resource () : string {
    return 'tenantUsers'
  }
}
